"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StylableSiteVars = exports.COLOR_VAR_CATEGORY_USER = exports.SITE_COLORS_VAR_SHADES = exports.SITE_COLORS_VARS = exports.DEFAULT_EVAL_DECLARATION_VALUE = exports.DEFAULT_WRAP_SITE_COLOR = exports.DEFAULT_LOAD_SITE_COLORS = exports.DEFAULT_USER_VAR_PATTERN_BUILDER = exports.DEFAULT_SITE_VAR_PATTERN_BUILDER = void 0;
var tslib_1 = require("tslib");
var chroma_js_1 = tslib_1.__importDefault(require("chroma-js"));
var DEFAULT_SITE_VAR_PATTERN_BUILDER = function (firstIndex, secondIndex) {
    if (firstIndex === void 0) { firstIndex = '(\\d+)'; }
    if (secondIndex === void 0) { secondIndex = '(\\d+)'; }
    return "site_".concat(firstIndex, "_").concat(secondIndex);
};
exports.DEFAULT_SITE_VAR_PATTERN_BUILDER = DEFAULT_SITE_VAR_PATTERN_BUILDER;
var DEFAULT_USER_VAR_PATTERN_BUILDER = function (index) {
    if (index === void 0) { index = '(\\d+)'; }
    return "".concat(exports.COLOR_VAR_CATEGORY_USER, "_").concat(index);
};
exports.DEFAULT_USER_VAR_PATTERN_BUILDER = DEFAULT_USER_VAR_PATTERN_BUILDER;
var DEFAULT_LOAD_SITE_COLORS = function () {
    /**/
};
exports.DEFAULT_LOAD_SITE_COLORS = DEFAULT_LOAD_SITE_COLORS;
var DEFAULT_WRAP_SITE_COLOR = function (value) { return value; };
exports.DEFAULT_WRAP_SITE_COLOR = DEFAULT_WRAP_SITE_COLOR;
var DEFAULT_EVAL_DECLARATION_VALUE = function (value) { return value || ''; };
exports.DEFAULT_EVAL_DECLARATION_VALUE = DEFAULT_EVAL_DECLARATION_VALUE;
exports.SITE_COLORS_VARS = 5;
exports.SITE_COLORS_VAR_SHADES = 5;
exports.COLOR_VAR_CATEGORY_USER = 'user';
var StylableSiteVars = /** @class */ (function () {
    function StylableSiteVars(sheet, siteVarPatternBuilder, userVarPatternBuilder) {
        if (siteVarPatternBuilder === void 0) { siteVarPatternBuilder = exports.DEFAULT_SITE_VAR_PATTERN_BUILDER; }
        if (userVarPatternBuilder === void 0) { userVarPatternBuilder = exports.DEFAULT_USER_VAR_PATTERN_BUILDER; }
        this.sheet = sheet;
        this.siteVarPatternBuilder = siteVarPatternBuilder;
        this.siteColors = [];
        this.newSiteColors = [];
        this.siteColorsMap = {};
        this.loadSiteColors();
        this.varCategories = {};
        this.addCategory(exports.COLOR_VAR_CATEGORY_USER, userVarPatternBuilder);
    }
    Object.defineProperty(StylableSiteVars.prototype, "userColors", {
        get: function () {
            return this.getCategoryValues(exports.COLOR_VAR_CATEGORY_USER);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StylableSiteVars.prototype, "userColorsMap", {
        get: function () {
            // @TODO optimize this
            return this.getCategoryValues(exports.COLOR_VAR_CATEGORY_USER).reduce(function (acc, _a) {
                var name = _a.name, value = _a.value;
                acc[name] = value;
                return acc;
            }, {});
        },
        enumerable: false,
        configurable: true
    });
    StylableSiteVars.prototype.loadSiteColors = function () {
        this.newSiteColors = this.sheet.getNewPalleteVars();
        var siteVarPattern = new RegExp(this.siteVarPatternBuilder('(\\d+)', '(\\d+)'));
        this.siteColors = [];
        var siteColors = this.sheet.getGroupVars(siteVarPattern, 2);
        if (siteColors.length === exports.SITE_COLORS_VARS &&
            siteColors.every(function (palette) { return palette.length === exports.SITE_COLORS_VAR_SHADES; })) {
            for (var i = 0; i < exports.SITE_COLORS_VAR_SHADES; i++) {
                for (var j = 0; j < exports.SITE_COLORS_VARS; j++) {
                    this.siteColors.push(siteColors[i][j]);
                }
            }
        }
        this.siteColorsMap = tslib_1.__spreadArray(tslib_1.__spreadArray([], tslib_1.__read(this.siteColors), false), tslib_1.__read(this.newSiteColors), false).reduce(function (acc, _a) {
            var name = _a.name, value = _a.value;
            acc[name] = value;
            return acc;
        }, {});
    };
    StylableSiteVars.prototype.addCategory = function (categoryName, patternBuilder) {
        this.varCategories[categoryName] = {
            patternBuilder: patternBuilder,
            values: this.sheet.getGroupVars(new RegExp(patternBuilder('(\\d+)')), 1),
        };
    };
    StylableSiteVars.prototype.getCategoryValues = function (categoryName) {
        return this.varCategories[categoryName].values;
    };
    StylableSiteVars.prototype.clearCategory = function (categoryName) {
        var _this = this;
        var category = this.varCategories[categoryName];
        if (!category) {
            return;
        }
        category.values.forEach(function (value) { return _this.sheet.deleteVar(value.name); });
        this.varCategories[categoryName].values = [];
    };
    StylableSiteVars.prototype.addValue = function (categoryName, value) {
        var category = this.varCategories[categoryName];
        if (!category) {
            return;
        }
        var _a = category.patternBuilder, patternBuilder = _a === void 0 ? exports.DEFAULT_USER_VAR_PATTERN_BUILDER : _a, values = category.values;
        var newVarIndex = 0;
        if (values.length !== 0) {
            var varPattern = new RegExp(patternBuilder('(\\d+)'));
            var lastVarName = values[values.length - 1].name;
            var nameMatch = lastVarName.match(varPattern);
            if (!nameMatch || nameMatch[1] === undefined) {
                return;
            }
            newVarIndex = parseInt(nameMatch[1], 10) + 1;
        }
        var newVarName = patternBuilder("".concat(newVarIndex));
        this.sheet.setVar(newVarName, value);
        this.varCategories[categoryName].values.push({ name: newVarName, value: value });
    };
    StylableSiteVars.prototype.removeUserValue = function (categoryName, index) {
        var category = this.varCategories[categoryName];
        if (!category) {
            return false;
        }
        var value = category.values[index];
        if (value) {
            this.sheet.deleteVar(value.name);
            category.values.splice(index, 1);
            return true;
        }
        return false;
    };
    // rename these function when colorpicker is updated in editor
    StylableSiteVars.prototype.findSiteColor__new = function (color, isNewPalette, _visibleColors) {
        return this.findColorInVarList__new(isNewPalette ? this.newSiteColors : this.siteColors, color);
    };
    StylableSiteVars.prototype.findColorInVarList__new = function (varList, color) {
        var _a;
        return (_a = varList.find(function (varObj) { return color.hex('rgb').toLowerCase() === (0, chroma_js_1.default)(varObj.value).hex('rgb').toLowerCase(); })) === null || _a === void 0 ? void 0 : _a.name;
    };
    StylableSiteVars.prototype.findUserColor__new = function (color) {
        return this.findColorInVarList__new(this.getCategoryValues(exports.COLOR_VAR_CATEGORY_USER), color);
    };
    StylableSiteVars.prototype.findSiteColor = function (color) {
        return this.findColorInVarList(this.siteColors, color);
    };
    StylableSiteVars.prototype.findUserColor = function (color) {
        return this.findColorInVarList(this.getCategoryValues(exports.COLOR_VAR_CATEGORY_USER), color);
    };
    StylableSiteVars.prototype.setSiteColors = function (columns) {
        var _this = this;
        columns.forEach(function (column, columnIndex) {
            column.forEach(function (value, colorIndex) {
                var name = _this.siteVarPatternBuilder("".concat(columnIndex + 1), "".concat(colorIndex + 1));
                _this.sheet.setVar(name, value);
                _this.siteColors[exports.SITE_COLORS_VAR_SHADES * colorIndex + columnIndex] = { name: name, value: value };
            });
        });
    };
    StylableSiteVars.prototype.addUserColor = function (value) {
        this.addValue(exports.COLOR_VAR_CATEGORY_USER, value);
    };
    StylableSiteVars.prototype.wrapSiteColor = function (value) {
        if (value.startsWith('value(')) {
            return value;
        }
        try {
            var valueColor_1 = (0, chroma_js_1.default)(value);
            var foundSiteColor = this.siteColors.find(function (varObj) {
                return valueColor_1.rgba().every(function (val, index) { return val === (0, chroma_js_1.default)(varObj.value).rgba()[index]; });
            });
            if (foundSiteColor) {
                return "value(".concat(foundSiteColor.name, ")");
            }
        }
        catch (_a) {
            //
        }
        return value;
    };
    StylableSiteVars.prototype.evalDeclarationValue = function (value) {
        return this.sheet.evalDeclarationValue(value);
    };
    StylableSiteVars.prototype.findColorInVarList = function (varList, color) {
        return varList.findIndex(function (varObj) { return color.hex('rgb') === (0, chroma_js_1.default)(varObj.value).hex('rgb'); });
    };
    return StylableSiteVars;
}());
exports.StylableSiteVars = StylableSiteVars;
//# sourceMappingURL=stylable-site-vars.js.map